/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { QueryCache } from "@tanstack/react-query";
// import toast from "react-hot-toast";
// import * as auth from 'auth-provider'


const apiURL = process.env.REACT_APP_API_URL;



const queryCache = new QueryCache({
  onError: (error) => {
    console.log(error);
  },
  onSuccess: (data) => {
    console.log(data);
  },
});

async function client(
  endpoint: string,
  {
    data,
    headers: customHeaders,
    ...customConfig
  }: Partial<RequestInit> & { data?: unknown } = {}
) {
  const token = localStorage.getItem("token");
  const config: RequestInit = {
    method: data ? "POST" : "GET",
    body: data instanceof FormData ? data : JSON.stringify(data),
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      ...(!data || data instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...customHeaders,
    },
    ...customConfig,
  };

  if (!apiURL) {
    throw new Error("REACT_APP_API_URL is not set");
  }


  return await window
    .fetch(`${apiURL}/${endpoint}`, config)
    .then(async (response) => {
      const responseData = await response.json();

      // Handle 401 - try to refresh token
      if (response.status === 401 && endpoint !== "admin/login" && endpoint !== "admin/refresh-token") {
        const refreshToken = localStorage.getItem("refreshToken");

        if (refreshToken) {
          try {
            // Try to refresh the token
            const refreshResponse = await window.fetch(`${apiURL}/admin/refresh-token`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ refreshToken }),
            });

            if (refreshResponse.ok) {
              const refreshData = await refreshResponse.json();
              const newAccessToken = refreshData.data?.accessToken;
              const newRefreshToken = refreshData.data?.refreshToken;

              if (newAccessToken && newRefreshToken) {
                const accessTokenStr = String(newAccessToken);
                const refreshTokenStr = String(newRefreshToken);
                localStorage.setItem("token", accessTokenStr);
                localStorage.setItem("refreshToken", refreshTokenStr);

                // Retry the original request with new token
                const retryConfig: RequestInit = {
                  ...config,
                  headers: {
                    ...config.headers,
                    Authorization: `Bearer ${accessTokenStr}`,
                  },
                };

                const retryResponse = await window.fetch(`${apiURL}/${endpoint}`, retryConfig);
                const retryData = await retryResponse.json();

                if (retryResponse.ok) {
                  return retryData;
                } else {
                  return await Promise.reject(new Error(JSON.stringify(retryData)));
                }
              }
            }
          } catch (error) {
            // Refresh failed, clear tokens and redirect to login
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            queryCache.clear();
            window.location.href = "/login";
            return await Promise.reject(new Error("Please re-authenticate."));
          }
        }

        // No refresh token or refresh failed
        queryCache.clear();
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
        return await Promise.reject(new Error("Please re-authenticate."));
      }

      if (response.ok) {
        return responseData;
      } else {
        // toast.error(responseData?.message);
        return await Promise.reject(responseData);
      }
    });
}

export { client };
